import React from "react";
import { Heading, Subheading } from "../../../design/heading";
import { ParentingPlanSection } from "../../../models/ParentingPlanSection";
import { Badge } from "../../../design/badge";

interface SidebarProps {
  sections: ParentingPlanSection[];
  selectedSection?: ParentingPlanSection["_id"];
  onSelect: (parentingPlanSectionId: ParentingPlanSection["_id"]) => void;
}

export const ParentingPlanSidebar: React.FC<SidebarProps> = ({
  sections,
  selectedSection,
  onSelect,
}) => {
  // Helper to count checked subsections
  const countCheckedSubsections = (section: ParentingPlanSection): number => {
    if (!section.sections || section.sections.length === 0) return 0;
    return section.sections.filter((sub) => sub.isChecked).length;
  };

  return (
    <div className="w-64 bg-white border-r">
      <Heading>Agreement Sections</Heading>
      <ul className="divide-y">
        {sections.map((section) => {
          const checkedCount = countCheckedSubsections(section);

          return (
            <li
              key={section._id}
              className={`p-4 cursor-pointer hover:bg-gray-100 ${
                selectedSection === section._id
                  ? "bg-gray-100 font-semibold"
                  : ""
              }`}
              onClick={() => onSelect(section._id)}
            >
              <div className="flex items-center justify-between">
                <Subheading>{section.title}</Subheading>
                {checkedCount > 0 && <Badge>{checkedCount}</Badge>}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
